<template>
<ItpPage
  :size="size"
  :header="documentTitle"
  :loaded="loaded"
  :noShow="!loaded"
  :modal="modal"
  itp-cname="RegisterView"
  :modalBindings="b_7315092382398562_modalBindings"
  @close="evh_7315092382398562_close($event, {})"
>
  <VueSlickgrid
    name="register"
    :headerTitle="'Registers'|pgettext('Register')"
    :items="selectedRegisterId && selectedVersionId ? ds : []"
    export-to-csv
    :exportToCsvFilename="'register-entries'|pgettext('filename')"
    footer-totals
    checkbox-row-selection
    :columnDefaults="b_2248226175642056_columnDefaults"
    :columns="b_2248226175642056_columns"
    class="page--grid"
    ref="grid"
    v-if="loaded"
    @command="evh_2248226175642056_command($event, {})"
    @selectedRowsChanged="evh_2248226175642056_selectedRowsChanged($event, {})"
  >
    <DIV
      class="flex-grow-1 d-flex"
      slot="toolbar"
    >
      <UcRegisterSelector
        v-model="states"
        cacheKey="registerView"
        @input="evh_6466705138206980_input($event, {})"
      >
      </UcRegisterSelector>
      <ItpButton
        :icon="$config.register.createEntry"
        :text="'Add entry...'|pgettext('Register')"
        size="sm"
        variant="light"
        class="mx-2"
        v-if="isRegisterSelected"
        @click="evh_8320016629450276_click($event, {})"
      >
      </ItpButton>
      <b-dropdown
        size="sm"
        variant="light"
        toggle-class="itp-button border"
        :tooltip="'Set status to selected items'|pgettext('Register')"
        :disabled="!selectedItems || !selectedItems.length || (
    actions.setStatus && actions.setStatus.isRunning
  )"
        class="mx-2"
        v-if="statuses && statuses.length"
      >
        <span
          slot="button-content"
        >
          <b-spinner
            small
            type="grow"
            class="mr-1"
            v-if="actions.setStatus.isRunning"
          >
          </b-spinner>
          <ItpText
            :text="'Set status'|pgettext('Register')"
            class="mx-1"
          >
          </ItpText>
        </span>
        <b-dropdown-item-button
          :disabled="!selectedItems || !selectedItems.length"
          :key="status"
          v-for="status in statuses"
          @click.prevent.stop="evh_5382094220310827_clickPreventStop($event, {status})"
        >
          <ItpText
            :text="status"
          >
          </ItpText>
        </b-dropdown-item-button>
        <hr>
        </hr>
        <b-dropdown-item-button
          :disabled="!selectedItems || !selectedItems.length"
          @click.prevent.stop="evh_8704926098283402_clickPreventStop($event, {})"
        >
          <ItpText
            :text="'Clear status'|pgettext('Register')"
          >
          </ItpText>
        </b-dropdown-item-button>
      </b-dropdown>
    </DIV>
  </VueSlickgrid>
  <template
    slot="footer"
    v-if="loaded"
  >
  </template>
</ItpPage>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

addRoute(
  {
    name: "registers",
    path: "/registers",
    component: "RegisterView"
  }
)

addRoute(
  {
    name: "letterRegister",
    path: "/letter-register",
    component: "RegisterView"
  }
)

addRoute(
  {
    name: "invoiceRegister",
    path: "/invoice-register",
    component: "RegisterView"
  }
)

@Component()
export default class RegisterView extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "page",
  };

  beforeCreate() {
    this.$$cache_states = new ComponentValueCache(this, "states", "RegisterView.states");
  }

  getQueryParameters(...args: any[]) {
    return {
      sort_mode: 'desc',
      register_id: this.selectedRegisterId,
      version_id: this.selectedVersionId
    }
  }

  invoiceTypeBadgeClass(...args: any[]) {
    const [row] = args;
    const cc = this.$config.invoice.types.colorCodes[row.invoice_type];
    return `bg-${cc.bg} text-${cc.text}`
  }

  priorityBadgeClass(...args: any[]) {
    const [row] = args;
    const priority = row.priority;

    if (priority == 1) {
      return `border border-purple-500 text-purple-500`
    }

    if (priority == 2) {
      return `border border-red-500 text-red-500`
    }
  }

  invoiceFormatter(...args: any[]) {
    const [grid] = args;

    if (!this._invoiceFormatter) {
      this._invoiceFormatter = grid.ALL_FORMATTERS.chain({
        formatters: [
          {
            name: 'template',
            format: '{{ document.invoice_number }}'
          },
          {
            name: 'link',
            href: '#',
            className: 'command-link'
          },
          {
            name: 'cellclass',
            value: row => ({
              'font-weight-bold': true,
              'bg-yellow-500 text-yellow-800': row.is_corrected,
              'bg-red-300 text-red-800': row.is_reversed,
            })
          }
        ]
      })
    }
    return this._invoiceFormatter;
  }

  referenceNumberFormatter(...args: any[]) {
    const [grid] = args;

    if (!this._referenceNumberFormatter) {
      this._referenceNumberFormatter = grid.ALL_FORMATTERS.getvalue({
        field: 'reference_number',
        source: 'row'
      });
    }
    return this._referenceNumberFormatter;
  }

  documentFormatter(...args: any[]) {
    const [row, cell, value, columnDef, data, grid] = args;
    if (value && value.invoice_number) {
      return this.invoiceFormatter(grid)(...args);
    }

    if (data.reference_number) {
      return this.referenceNumberFormatter(grid)(
        row, cell, data.reference_number, columnDef, data, grid
      );
    }
  }

  @Prop({
    type: String,
    default: "md",
  })
  size!: string;

  @Watch('size')
  onSize(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("size")
  }

  states!: any;
  selectedItems!: any;
  statuses!: any;

  async $$load_statuses() {
    return this.$fn.fetch('get_tags', { parameters: { tag_type: 'register-entry:status' } }).then(data => _.map(data, p => p.name))
  }

  selectedStatus!: any;
  ds!: any;

  async $$load_ds() {
    return this.$fn.slickDataSource('list_register_entries', { parameters: this.getQueryParameters })
  }

  ux!: any;
  b_7315092382398562_modalBindings!: any;
  b_2248226175642056_columnDefaults!: any;
  b_2248226175642056_columns!: any;

  async $$load_b_2248226175642056_columns() {
    return [{
      field: "entry_number",
      name: this.$fn.pgettext("Register", "No."),
      type: "command",
      formatter: [{
        name: "chain",
        formatters: [{
          name: "link",
          href: "#",
        }
          ,
        {
          name: "cellclass",
          value: (row) => ({
            'font-weight-bold': true,
            'bg-yellow-200': !row.locked,
            'bg-gray-dark-100': row.locked,
            'text-decoration-line-through': row.void,
          }),
        }
          ,
        ]
        ,
      }
        ,
      ]
      ,
    }
      ,
    {
      field: "entry_date",
      name: this.$fn.pgettext("Register", "Date"),
      type: "date",
    }
      ,
    {
      field: "direction",
      name: this.$fn.pgettext("Register", "Direction"),
      formatter: {
        name: "chain",
        formatters: [{
          name: "gettext",
          context: "RegisterEntryDirection",
          conversion: "StartCase",
          filterInput: true,
        }
          ,
        ]
        ,
      }
      ,
    }
      ,
    {
      field: "document_type",
      name: this.$fn.pgettext("Register", "Document type"),
      formatter: {
        name: "chain",
        formatters: [{
          name: "gettext",
          context: "RegisterDocumentType",
          conversion: "StartCase",
          filterInput: true,
        }
          ,
        ]
        ,
      }
      ,
    }
      ,
    {
      field: "attachments",
      name: this.$fn.pgettext("Register", "Attachments"),
      type: "command",
      formatter: {
        name: "attachment",
      }
      ,
    }
      ,
    {
      field: "delivery_modes",
      name: this.$fn.pgettext("Register", "Delivery mode"),
      formatter: {
        name: "join",
        separator: ", ",
      }
      ,
    }
      ,
    {
      field: "clerk",
      name: this.$fn.pgettext("Register", "Clerk"),
    }
      ,
    {
      field: "project",
      name: this.$fn.pgettext("Register", "Project"),
      formatter: {
        name: "chain",
        mode: "mapReduce",
        formatterContext: "item",
        formatters: [{
          name: "getvalue",
          opts: {
            field: "code,name",
            source: "value",
            separator: " • ",
          }
          ,
        }
          ,
        {
          name: "routeLink",
          to: "project",
          navigateOnIconClick: true,
          params: {
            id: "id",
          }
          ,
        }
          ,
        ]
        ,
      }
      ,
    }
      ,
    {
      field: "priority",
      name: this.$fn.pgettext("Register", "Priority"),
      formatter: {
        name: "chain",
        formatters: [{
          name: "mapvalue",
          mapping: {
            0: this.$fn.pgettext("Priority", "normal"),
            1: this.$fn.pgettext("Priority", "important"),
            2: this.$fn.pgettext("Priority", "urgent"),
          }
          ,
        }
          ,
        {
          name: "badge",
          pill: true,
          badgeClass: this.priorityBadgeClass,
        }
          ,
        ]
        ,
      }
      ,
    }
      ,
    {
      field: "document",
      name: this.$fn.pgettext("Register", "Document"),
      type: "command",
      formatter: this.documentFormatter,
    }
      ,
    {
      field: "partner",
      name: this.$fn.pgettext("Register", "Partner"),
      formatter: {
        name: "chain",
        mode: "mapReduce",
        formatterContext: "item",
        formatters: [{
          name: "getvalue",
          opts: {
            field: "name",
            source: "value",
          }
          ,
        }
          ,
        {
          name: "routeLink",
          to: "company",
          navigateOnIconClick: true,
          params: {
            id: "id",
          }
          ,
        }
          ,
        ]
        ,
      }
      ,
    }
      ,
    {
      field: "subject",
      name: this.$fn.pgettext("Register", "Subject"),
    }
      ,
    {
      field: "ref_entry_number",
      name: this.$fn.pgettext("Register", "Ref."),
      type: "command",
      formatter: [{
        name: "chain",
        formatters: [{
          name: "link",
          href: "#",
        }
          ,
        ]
        ,
      }
        ,
      ]
      ,
    }
      ,
    {
      field: "status",
      name: this.$fn.pgettext("Register", "Status"),
    }
      ,
    {
      field: "categories",
      name: this.$fn.pgettext("Register", "Category"),
    }
      ,
    {
      field: "delivery_date",
      name: this.$fn.pgettext("Register", "Delivery date"),
      type: "date",
    }
      ,
    {
      field: "notes",
      name: this.$fn.pgettext("Register", "Notes"),
    }
      ,
    {
      field: "created_at",
      name: this.$fn.pgettext("BrowserColumn", "Create time"),
      formatter: "datetime",
    }
      ,
    ]
  }

  dataMembers = ['states', 'selectedItems', 'statuses', 'selectedStatus', 'ds', 'ux', 'b_7315092382398562_modalBindings', 'b_2248226175642056_columnDefaults', 'b_2248226175642056_columns'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        states: {
          selectedRegisterId: null,
          selectedVersionId: null,
        }
        ,
        selectedItems: [
        ]
        ,
        statuses: null,
        selectedStatus: null,
        ds: null,
        ux: null,
        b_7315092382398562_modalBindings: {
          size: "sm",
        }
        ,
        b_2248226175642056_columnDefaults: {
          filterable: true,
          resizable: true,
          selectable: true,
        }
        ,
        b_2248226175642056_columns: null,
      },
    }
  }

  get selectedRegisterId() {
    if (this.loaded) {

      return this.states.selectedRegisterId
    }
    return null;
  }

  get selectedVersionId() {
    if (this.loaded) {

      return this.states.selectedVersionId
    }
    return null;
  }

  get isRegisterSelected() {
    if (this.loaded) {

      return this.selectedRegisterId && this.selectedVersionId
    }
    return null;
  }

  get document() {
    if (this.loaded) {

      return {
        title: this.$fn.pgettext("Register", "Registers"),
        icon: this.$config.register.icon,
      }
    }
    return null;
  }

  async act_7315092382398562_closeModal_4332_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_7315092382398562_closeModal_4332, alias=undefined
    return {
      name: this.modalName,
      result: {
        close: true,
        cancel: true,
      }
      ,
    }
  }

  async evh_7315092382398562_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
  }

  async act_2248226175642056_reloadSlickgrid_4336_getActionArgs($event: actions.ActionEvent): Promise<actions.ReloadSlickgridActionArgs> {
    // parameterResolver name=act_2248226175642056_reloadSlickgrid_4336, alias=reloadSlickgrid
    return {
      grid: "register",
    }
  }

  async act_2248226175642056_reloadSlickgrid_4338_getActionArgs($event: actions.ActionEvent): Promise<actions.ReloadSlickgridActionArgs> {
    // parameterResolver name=act_2248226175642056_reloadSlickgrid_4338, alias=reloadSlickgrid
    return {
      grid: "register",
    }
  }

  async evh_2248226175642056_close_4337_getWhen($event: actions.ActionEvent): Promise<actions.EventHandlerImplArgs> {
    // parameterResolver name=evh_2248226175642056_close_4337, alias=undefined
    return !!$event.data.modalResult.ok
  }

  async act_2248226175642056_showModal_4334_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_2248226175642056_showModal_4334, alias=showRegisterEntryModal
    return {
      name: "RegisterEntry",
      props: {
        oid: $event.data.data.id,
      }
      ,
    }
  }

  async evh_2248226175642056_command_4333_getWhen($event: actions.ActionEvent): Promise<actions.EventHandlerImplArgs> {
    // parameterResolver name=evh_2248226175642056_command_4333, alias=undefined
    return $event.data.column.id === 'entry_number'
  }

  async act_2248226175642056_reloadSlickgrid_4342_getActionArgs($event: actions.ActionEvent): Promise<actions.ReloadSlickgridActionArgs> {
    // parameterResolver name=act_2248226175642056_reloadSlickgrid_4342, alias=reloadSlickgrid
    return {
      grid: "register",
    }
  }

  async act_2248226175642056_reloadSlickgrid_4344_getActionArgs($event: actions.ActionEvent): Promise<actions.ReloadSlickgridActionArgs> {
    // parameterResolver name=act_2248226175642056_reloadSlickgrid_4344, alias=reloadSlickgrid
    return {
      grid: "register",
    }
  }

  async evh_2248226175642056_close_4343_getWhen($event: actions.ActionEvent): Promise<actions.EventHandlerImplArgs> {
    // parameterResolver name=evh_2248226175642056_close_4343, alias=undefined
    return !!$event.data.modalResult.ok
  }

  async act_2248226175642056_showModal_4340_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_2248226175642056_showModal_4340, alias=showRefEntryModal
    return {
      name: "RegisterEntry",
      props: {
        oid: $event.data.data.ref_entry_id,
      }
      ,
    }
  }

  async evh_2248226175642056_command_4339_getWhen($event: actions.ActionEvent): Promise<actions.EventHandlerImplArgs> {
    // parameterResolver name=evh_2248226175642056_command_4339, alias=undefined
    return $event.data.column.id === 'ref_entry_number'
  }

  async act_2248226175642056_script_4346_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_2248226175642056_script_4346, alias=undefined
    this.$app.attachments.downloadAttachmentFromSlickCommand($event)
  }

  async act_2248226175642056_script_4346_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_2248226175642056_script_4346, alias=undefined
    return {
      value: () => this.act_2248226175642056_script_4346_getActionArgs_value($event),
    }
  }

  async evh_2248226175642056_command_4345_getWhen($event: actions.ActionEvent): Promise<actions.EventHandlerImplArgs> {
    // parameterResolver name=evh_2248226175642056_command_4345, alias=undefined
    return $event.data.column.id === 'attachments'
  }

  async act_2248226175642056_showModal_4348_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_2248226175642056_showModal_4348, alias=showInvoiceModal
    return {
      name: "Invoice",
      props: {
        oid: $event.data.data.document.id,
      }
      ,
    }
  }

  async evh_2248226175642056_command_4347_getWhen($event: actions.ActionEvent): Promise<actions.EventHandlerImplArgs> {
    // parameterResolver name=evh_2248226175642056_command_4347, alias=undefined
    return $event.data.column.id === 'document' &&
      !!$event.data.data.document &&
      !!$event.data.data.document.invoice_number
  }

  async evh_2248226175642056_command(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2248226175642056_command.executeFromDOM(this, event, scope);
  }

  async act_2248226175642056_setData_4350_getActionArgs($event: actions.ActionEvent): Promise<actions.SetDataActionArgs> {
    // parameterResolver name=act_2248226175642056_setData_4350, alias=undefined
    return {
      path: "selectedItems",
      value: this.$refs.grid.getSelectedItems(),
      resolve: false,
      noTouchLastLoaded: false,
      noTakeSnapshot: false,
    }
  }

  async evh_2248226175642056_selectedRowsChanged(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2248226175642056_selectedRowsChanged.executeFromDOM(this, event, scope);
  }

  async act_6466705138206980_reloadSlickgrid_4352_getActionArgs($event: actions.ActionEvent): Promise<actions.ReloadSlickgridActionArgs> {
    // parameterResolver name=act_6466705138206980_reloadSlickgrid_4352, alias=undefined
    return {
      grid: "register",
    }
  }

  async evh_6466705138206980_input(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_6466705138206980_input.executeFromDOM(this, event, scope);
  }

  async act_8320016629450276_reloadSlickgrid_4356_getActionArgs($event: actions.ActionEvent): Promise<actions.ReloadSlickgridActionArgs> {
    // parameterResolver name=act_8320016629450276_reloadSlickgrid_4356, alias=reloadSlickgrid
    return {
      grid: "register",
    }
  }

  async act_8320016629450276_reloadSlickgrid_4358_getActionArgs($event: actions.ActionEvent): Promise<actions.ReloadSlickgridActionArgs> {
    // parameterResolver name=act_8320016629450276_reloadSlickgrid_4358, alias=reloadSlickgrid
    return {
      grid: "register",
    }
  }

  async evh_8320016629450276_close_4357_getWhen($event: actions.ActionEvent): Promise<actions.EventHandlerImplArgs> {
    // parameterResolver name=evh_8320016629450276_close_4357, alias=undefined
    return !!$event.data.modalResult.ok
  }

  async act_8320016629450276_showModal_4354_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_8320016629450276_showModal_4354, alias=undefined
    return {
      name: "RegisterEntry",
      props: {
        registerId: this.states.selectedRegisterId,
        versionId: this.states.selectedVersionId,
      }
      ,
    }
  }

  async evh_8320016629450276_click(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_8320016629450276_click.executeFromDOM(this, event, scope);
  }

  async act_5382094220310827_setData_4360_getActionArgs($event: actions.ActionEvent): Promise<actions.SetDataActionArgs> {
    // parameterResolver name=act_5382094220310827_setData_4360, alias=undefined
    return {
      path: "selectedStatus",
      value: $event.scope.status,
      resolve: false,
      noTouchLastLoaded: false,
      noTakeSnapshot: false,
    }
  }

  async act_5382094220310827_reloadSlickgrid_4364_getActionArgs($event: actions.ActionEvent): Promise<actions.ReloadSlickgridActionArgs> {
    // parameterResolver name=act_5382094220310827_reloadSlickgrid_4364, alias=reloadSlickgrid
    return {
      grid: "register",
    }
  }

  async act_5382094220310827_request_4362_getActionArgs($event: actions.ActionEvent): Promise<actions.RequestActionArgs> {
    // parameterResolver name=act_5382094220310827_request_4362, alias=setStatus
    return {
      operation: "bulk_update_register_entry",
      data: _.map(this.selectedItems, p => ({ id: p.id, status: this.selectedStatus })),
    }
  }

  async evh_5382094220310827_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_5382094220310827_clickPreventStop.executeFromDOM(this, event, scope);
  }

  async act_8704926098283402_setData_4366_getActionArgs($event: actions.ActionEvent): Promise<actions.SetDataActionArgs> {
    // parameterResolver name=act_8704926098283402_setData_4366, alias=undefined
    return {
      path: "selectedStatus",
      value: null,
      resolve: false,
      noTouchLastLoaded: false,
      noTakeSnapshot: false,
    }
  }

  async act_8704926098283402_reloadSlickgrid_4370_getActionArgs($event: actions.ActionEvent): Promise<actions.ReloadSlickgridActionArgs> {
    // parameterResolver name=act_8704926098283402_reloadSlickgrid_4370, alias=reloadSlickgrid
    return {
      grid: "register",
    }
  }

  async act_8704926098283402_request_4368_getActionArgs($event: actions.ActionEvent): Promise<actions.RequestActionArgs> {
    // parameterResolver name=act_8704926098283402_request_4368, alias=setStatus
    return {
      operation: "bulk_update_register_entry",
      data: _.map(this.selectedItems, p => ({ id: p.id, status: this.selectedStatus })),
    }
  }

  async evh_8704926098283402_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_8704926098283402_clickPreventStop.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_closeModal_4332: actions.CloseModalAction;
    evh_7315092382398562_close_4331: actions.EventHandlerImpl;
    evh_7315092382398562_close: actions.EventHandlerGroup;
    act_2248226175642056_reloadSlickgrid_4336: actions.ReloadSlickgridAction;
    evh_2248226175642056_saved_4335: actions.EventHandlerImpl;
    act_2248226175642056_reloadSlickgrid_4338: actions.ReloadSlickgridAction;
    evh_2248226175642056_close_4337: actions.EventHandlerImpl;
    act_2248226175642056_showModal_4334: actions.ShowModalAction;
    evh_2248226175642056_command_4333: actions.EventHandlerImpl;
    act_2248226175642056_reloadSlickgrid_4342: actions.ReloadSlickgridAction;
    evh_2248226175642056_saved_4341: actions.EventHandlerImpl;
    act_2248226175642056_reloadSlickgrid_4344: actions.ReloadSlickgridAction;
    evh_2248226175642056_close_4343: actions.EventHandlerImpl;
    act_2248226175642056_showModal_4340: actions.ShowModalAction;
    evh_2248226175642056_command_4339: actions.EventHandlerImpl;
    act_2248226175642056_script_4346: actions.ScriptAction;
    evh_2248226175642056_command_4345: actions.EventHandlerImpl;
    act_2248226175642056_showModal_4348: actions.ShowModalAction;
    evh_2248226175642056_command_4347: actions.EventHandlerImpl;
    evh_2248226175642056_command: actions.EventHandlerGroup;
    act_2248226175642056_setData_4350: actions.SetDataAction;
    evh_2248226175642056_selectedRowsChanged_4349: actions.EventHandlerImpl;
    evh_2248226175642056_selectedRowsChanged: actions.EventHandlerGroup;
    act_6466705138206980_reloadSlickgrid_4352: actions.ReloadSlickgridAction;
    evh_6466705138206980_input_4351: actions.EventHandlerImpl;
    evh_6466705138206980_input: actions.EventHandlerGroup;
    act_8320016629450276_reloadSlickgrid_4356: actions.ReloadSlickgridAction;
    evh_8320016629450276_saved_4355: actions.EventHandlerImpl;
    act_8320016629450276_reloadSlickgrid_4358: actions.ReloadSlickgridAction;
    evh_8320016629450276_close_4357: actions.EventHandlerImpl;
    act_8320016629450276_showModal_4354: actions.ShowModalAction;
    evh_8320016629450276_click_4353: actions.EventHandlerImpl;
    evh_8320016629450276_click: actions.EventHandlerGroup;
    act_5382094220310827_setData_4360: actions.SetDataAction;
    evh_5382094220310827_clickPreventStop_4359: actions.EventHandlerImpl;
    act_5382094220310827_reloadSlickgrid_4364: actions.ReloadSlickgridAction;
    evh_5382094220310827_success_4363: actions.EventHandlerImpl;
    act_5382094220310827_request_4362: actions.RequestAction;
    evh_5382094220310827_clickPreventStop_4361: actions.EventHandlerImpl;
    evh_5382094220310827_clickPreventStop: actions.EventHandlerGroup;
    act_8704926098283402_setData_4366: actions.SetDataAction;
    evh_8704926098283402_clickPreventStop_4365: actions.EventHandlerImpl;
    act_8704926098283402_reloadSlickgrid_4370: actions.ReloadSlickgridAction;
    evh_8704926098283402_success_4369: actions.EventHandlerImpl;
    act_8704926098283402_request_4368: actions.RequestAction;
    evh_8704926098283402_clickPreventStop_4367: actions.EventHandlerImpl;
    evh_8704926098283402_clickPreventStop: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_closeModal_4332 = new actions.CloseModalAction(
      {
        actionArgs: this.act_7315092382398562_closeModal_4332_getActionArgs,
        events: [],
      }
    );
    const evh_7315092382398562_close_4331 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_closeModal_4332,
        event: "close",
        displayName: "closeModal",
      }
    );
    const evh_7315092382398562_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_close_4331],
      }
    );
    const act_2248226175642056_reloadSlickgrid_4336 = new actions.ReloadSlickgridAction(
      {
        actionArgs: this.act_2248226175642056_reloadSlickgrid_4336_getActionArgs,
        displayName: "reloadSlickgrid",
        events: [],
      }
    );
    const evh_2248226175642056_saved_4335 = new actions.EventHandlerImpl(
      {
        action: act_2248226175642056_reloadSlickgrid_4336,
        event: "saved",
        displayName: "reloadSlickgrid",
      }
    );
    const act_2248226175642056_reloadSlickgrid_4338 = new actions.ReloadSlickgridAction(
      {
        actionArgs: this.act_2248226175642056_reloadSlickgrid_4338_getActionArgs,
        displayName: "reloadSlickgrid",
        events: [],
      }
    );
    const evh_2248226175642056_close_4337 = new actions.EventHandlerImpl(
      {
        action: act_2248226175642056_reloadSlickgrid_4338,
        event: "close",
        when: this.evh_2248226175642056_close_4337_getWhen,
        displayName: "reloadSlickgrid",
      }
    );
    const act_2248226175642056_showModal_4334 = new actions.ShowModalAction(
      {
        actionArgs: this.act_2248226175642056_showModal_4334_getActionArgs,
        displayName: "showRegisterEntryModal",
        events: [evh_2248226175642056_saved_4335, evh_2248226175642056_close_4337],
      }
    );
    const evh_2248226175642056_command_4333 = new actions.EventHandlerImpl(
      {
        action: act_2248226175642056_showModal_4334,
        event: "command",
        when: this.evh_2248226175642056_command_4333_getWhen,
        displayName: "showRegisterEntryModal",
      }
    );
    const act_2248226175642056_reloadSlickgrid_4342 = new actions.ReloadSlickgridAction(
      {
        actionArgs: this.act_2248226175642056_reloadSlickgrid_4342_getActionArgs,
        displayName: "reloadSlickgrid",
        events: [],
      }
    );
    const evh_2248226175642056_saved_4341 = new actions.EventHandlerImpl(
      {
        action: act_2248226175642056_reloadSlickgrid_4342,
        event: "saved",
        displayName: "reloadSlickgrid",
      }
    );
    const act_2248226175642056_reloadSlickgrid_4344 = new actions.ReloadSlickgridAction(
      {
        actionArgs: this.act_2248226175642056_reloadSlickgrid_4344_getActionArgs,
        displayName: "reloadSlickgrid",
        events: [],
      }
    );
    const evh_2248226175642056_close_4343 = new actions.EventHandlerImpl(
      {
        action: act_2248226175642056_reloadSlickgrid_4344,
        event: "close",
        when: this.evh_2248226175642056_close_4343_getWhen,
        displayName: "reloadSlickgrid",
      }
    );
    const act_2248226175642056_showModal_4340 = new actions.ShowModalAction(
      {
        actionArgs: this.act_2248226175642056_showModal_4340_getActionArgs,
        displayName: "showRefEntryModal",
        events: [evh_2248226175642056_saved_4341, evh_2248226175642056_close_4343],
      }
    );
    const evh_2248226175642056_command_4339 = new actions.EventHandlerImpl(
      {
        action: act_2248226175642056_showModal_4340,
        event: "command",
        when: this.evh_2248226175642056_command_4339_getWhen,
        displayName: "showRefEntryModal",
      }
    );
    const act_2248226175642056_script_4346 = new actions.ScriptAction(
      {
        actionArgs: this.act_2248226175642056_script_4346_getActionArgs,
        events: [],
      }
    );
    const evh_2248226175642056_command_4345 = new actions.EventHandlerImpl(
      {
        action: act_2248226175642056_script_4346,
        event: "command",
        when: this.evh_2248226175642056_command_4345_getWhen,
        displayName: "script",
      }
    );
    const act_2248226175642056_showModal_4348 = new actions.ShowModalAction(
      {
        actionArgs: this.act_2248226175642056_showModal_4348_getActionArgs,
        displayName: "showInvoiceModal",
        events: [],
      }
    );
    const evh_2248226175642056_command_4347 = new actions.EventHandlerImpl(
      {
        action: act_2248226175642056_showModal_4348,
        event: "command",
        when: this.evh_2248226175642056_command_4347_getWhen,
        displayName: "showInvoiceModal",
      }
    );
    const evh_2248226175642056_command = new actions.EventHandlerGroup(
      {
        handlers: [evh_2248226175642056_command_4333, evh_2248226175642056_command_4339, evh_2248226175642056_command_4345, evh_2248226175642056_command_4347],
      }
    );
    const act_2248226175642056_setData_4350 = new actions.SetDataAction(
      {
        actionArgs: this.act_2248226175642056_setData_4350_getActionArgs,
        events: [],
      }
    );
    const evh_2248226175642056_selectedRowsChanged_4349 = new actions.EventHandlerImpl(
      {
        action: act_2248226175642056_setData_4350,
        event: "selectedRowsChanged",
        displayName: "setData",
      }
    );
    const evh_2248226175642056_selectedRowsChanged = new actions.EventHandlerGroup(
      {
        handlers: [evh_2248226175642056_selectedRowsChanged_4349],
      }
    );
    const act_6466705138206980_reloadSlickgrid_4352 = new actions.ReloadSlickgridAction(
      {
        actionArgs: this.act_6466705138206980_reloadSlickgrid_4352_getActionArgs,
        events: [],
      }
    );
    const evh_6466705138206980_input_4351 = new actions.EventHandlerImpl(
      {
        action: act_6466705138206980_reloadSlickgrid_4352,
        event: "input",
        displayName: "reloadSlickgrid",
      }
    );
    const evh_6466705138206980_input = new actions.EventHandlerGroup(
      {
        handlers: [evh_6466705138206980_input_4351],
      }
    );
    const act_8320016629450276_reloadSlickgrid_4356 = new actions.ReloadSlickgridAction(
      {
        actionArgs: this.act_8320016629450276_reloadSlickgrid_4356_getActionArgs,
        displayName: "reloadSlickgrid",
        events: [],
      }
    );
    const evh_8320016629450276_saved_4355 = new actions.EventHandlerImpl(
      {
        action: act_8320016629450276_reloadSlickgrid_4356,
        event: "saved",
        displayName: "reloadSlickgrid",
      }
    );
    const act_8320016629450276_reloadSlickgrid_4358 = new actions.ReloadSlickgridAction(
      {
        actionArgs: this.act_8320016629450276_reloadSlickgrid_4358_getActionArgs,
        displayName: "reloadSlickgrid",
        events: [],
      }
    );
    const evh_8320016629450276_close_4357 = new actions.EventHandlerImpl(
      {
        action: act_8320016629450276_reloadSlickgrid_4358,
        event: "close",
        when: this.evh_8320016629450276_close_4357_getWhen,
        displayName: "reloadSlickgrid",
      }
    );
    const act_8320016629450276_showModal_4354 = new actions.ShowModalAction(
      {
        actionArgs: this.act_8320016629450276_showModal_4354_getActionArgs,
        events: [evh_8320016629450276_saved_4355, evh_8320016629450276_close_4357],
      }
    );
    const evh_8320016629450276_click_4353 = new actions.EventHandlerImpl(
      {
        action: act_8320016629450276_showModal_4354,
        event: "click",
        displayName: "showModal",
      }
    );
    const evh_8320016629450276_click = new actions.EventHandlerGroup(
      {
        handlers: [evh_8320016629450276_click_4353],
      }
    );
    const act_5382094220310827_setData_4360 = new actions.SetDataAction(
      {
        actionArgs: this.act_5382094220310827_setData_4360_getActionArgs,
        events: [],
      }
    );
    const evh_5382094220310827_clickPreventStop_4359 = new actions.EventHandlerImpl(
      {
        action: act_5382094220310827_setData_4360,
        event: "click.prevent.stop",
        displayName: "setData",
      }
    );
    const act_5382094220310827_reloadSlickgrid_4364 = new actions.ReloadSlickgridAction(
      {
        actionArgs: this.act_5382094220310827_reloadSlickgrid_4364_getActionArgs,
        displayName: "reloadSlickgrid",
        events: [],
      }
    );
    const evh_5382094220310827_success_4363 = new actions.EventHandlerImpl(
      {
        action: act_5382094220310827_reloadSlickgrid_4364,
        event: "success",
        displayName: "reloadSlickgrid",
      }
    );
    const act_5382094220310827_request_4362 = new actions.RequestAction(
      {
        actionArgs: this.act_5382094220310827_request_4362_getActionArgs,
        displayName: "setStatus",
        events: [evh_5382094220310827_success_4363],
      }
    );
    const evh_5382094220310827_clickPreventStop_4361 = new actions.EventHandlerImpl(
      {
        action: act_5382094220310827_request_4362,
        event: "click.prevent.stop",
        displayName: "setStatus",
      }
    );
    const evh_5382094220310827_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_5382094220310827_clickPreventStop_4359, evh_5382094220310827_clickPreventStop_4361],
      }
    );
    const act_8704926098283402_setData_4366 = new actions.SetDataAction(
      {
        actionArgs: this.act_8704926098283402_setData_4366_getActionArgs,
        events: [],
      }
    );
    const evh_8704926098283402_clickPreventStop_4365 = new actions.EventHandlerImpl(
      {
        action: act_8704926098283402_setData_4366,
        event: "click.prevent.stop",
        displayName: "setData",
      }
    );
    const act_8704926098283402_reloadSlickgrid_4370 = new actions.ReloadSlickgridAction(
      {
        actionArgs: this.act_8704926098283402_reloadSlickgrid_4370_getActionArgs,
        displayName: "reloadSlickgrid",
        events: [],
      }
    );
    const evh_8704926098283402_success_4369 = new actions.EventHandlerImpl(
      {
        action: act_8704926098283402_reloadSlickgrid_4370,
        event: "success",
        displayName: "reloadSlickgrid",
      }
    );
    const act_8704926098283402_request_4368 = new actions.RequestAction(
      {
        actionArgs: this.act_8704926098283402_request_4368_getActionArgs,
        displayName: "setStatus",
        events: [evh_8704926098283402_success_4369],
      }
    );
    const evh_8704926098283402_clickPreventStop_4367 = new actions.EventHandlerImpl(
      {
        action: act_8704926098283402_request_4368,
        event: "click.prevent.stop",
        displayName: "setStatus",
      }
    );
    const evh_8704926098283402_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_8704926098283402_clickPreventStop_4365, evh_8704926098283402_clickPreventStop_4367],
      }
    );
    return {
      act_7315092382398562_closeModal_4332,
      evh_7315092382398562_close_4331,
      evh_7315092382398562_close,
      act_2248226175642056_reloadSlickgrid_4336,
      evh_2248226175642056_saved_4335,
      act_2248226175642056_reloadSlickgrid_4338,
      evh_2248226175642056_close_4337,
      act_2248226175642056_showModal_4334,
      evh_2248226175642056_command_4333,
      act_2248226175642056_reloadSlickgrid_4342,
      evh_2248226175642056_saved_4341,
      act_2248226175642056_reloadSlickgrid_4344,
      evh_2248226175642056_close_4343,
      act_2248226175642056_showModal_4340,
      evh_2248226175642056_command_4339,
      act_2248226175642056_script_4346,
      evh_2248226175642056_command_4345,
      act_2248226175642056_showModal_4348,
      evh_2248226175642056_command_4347,
      evh_2248226175642056_command,
      act_2248226175642056_setData_4350,
      evh_2248226175642056_selectedRowsChanged_4349,
      evh_2248226175642056_selectedRowsChanged,
      act_6466705138206980_reloadSlickgrid_4352,
      evh_6466705138206980_input_4351,
      evh_6466705138206980_input,
      act_8320016629450276_reloadSlickgrid_4356,
      evh_8320016629450276_saved_4355,
      act_8320016629450276_reloadSlickgrid_4358,
      evh_8320016629450276_close_4357,
      act_8320016629450276_showModal_4354,
      evh_8320016629450276_click_4353,
      evh_8320016629450276_click,
      act_5382094220310827_setData_4360,
      evh_5382094220310827_clickPreventStop_4359,
      act_5382094220310827_reloadSlickgrid_4364,
      evh_5382094220310827_success_4363,
      act_5382094220310827_request_4362,
      evh_5382094220310827_clickPreventStop_4361,
      evh_5382094220310827_clickPreventStop,
      act_8704926098283402_setData_4366,
      evh_8704926098283402_clickPreventStop_4365,
      act_8704926098283402_reloadSlickgrid_4370,
      evh_8704926098283402_success_4369,
      act_8704926098283402_request_4368,
      evh_8704926098283402_clickPreventStop_4367,
      evh_8704926098283402_clickPreventStop,
      reloadSlickgrid: act_8704926098283402_reloadSlickgrid_4370,
      showRegisterEntryModal: act_2248226175642056_showModal_4334,
      showRefEntryModal: act_2248226175642056_showModal_4340,
      showInvoiceModal: act_2248226175642056_showModal_4348,
      setStatus: act_8704926098283402_request_4368,
    }
  }
}

Vue.component("RegisterView", RegisterView);

</script>